module.exports = __webpack_public_path__ + "static/media/jordi.d69dabc2.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jordi.jpeg
// module id = 627
// module chunks = 0